import { BaseMap } from '@app/components/BaseMap/BaseMap'
import { MapConfig } from '@app/components/BaseMap/config'
import { ContextualSingleLayer } from '@app/components/BaseMap/layers/ContextualSingleLayer'
import { ElementSingleLayer } from '@app/components/BaseMap/layers/ElementSingleLayer'
import { HazardSingleLayer } from '@app/components/BaseMap/layers/HazardSingleLayer'
import { clientLocationAtom } from '@app/state/clientsAtom'
import type { ContextualLayer } from '@app/domains/layers/types/layers.types'
import { ElementItem } from '@app/domains/layers/types/layers.types'
import { useAtomValue } from 'jotai'
import mapboxgl from 'mapbox-gl'
import { useCallback, useMemo, useState } from 'react'

type RiskDataDetailMapProps = {
  tilesetIds: string[]
  element?: ElementItem | null
  elementId?: string
  contextual?: ContextualLayer | null
  contextualId?: string
}

export const DataLayerDetailMap = ({
  tilesetIds,
  element,
  elementId,
  contextual,
  contextualId,
}: RiskDataDetailMapProps) => {
  const [map, setMap] = useState<mapboxgl.Map | null>(null)
  const clientLocation = useAtomValue(clientLocationAtom)

  const onMapReady = useCallback((m: mapboxgl.Map | null) => {
    setMap(m)
  }, [])

  const initialView = useMemo(
    () => ({
      center: clientLocation
        ? ([clientLocation.longitude, clientLocation.latitude] as [number, number])
        : MapConfig.locations.newZealand.center,
      zoom: clientLocation?.zoom ?? MapConfig.zoom.region,
      pitch: 0,
      bearing: 0,
    }),
    [clientLocation],
  )

  return (
    <BaseMap
      initialView={initialView}
      style={MapConfig.styles[MapConfig.defaults.style]}
      onMapReady={onMapReady}
    >
      {map && element && (
        <ElementSingleLayer
          map={map}
          element={element}
          elementId={elementId}
          namespace="risk-data-detail"
        />
      )}

      {map && contextual && (
        <ContextualSingleLayer
          map={map}
          layer={contextual}
          layerId={contextualId}
          namespace="risk-data-detail"
        />
      )}

      {map && tilesetIds?.length > 0 && (
        <HazardSingleLayer
          map={map}
          tilesetId={tilesetIds[0]}
          hazardId={tilesetIds[0]}
          namespace="risk-data-detail"
        />
      )}
    </BaseMap>
  )
}

export default DataLayerDetailMap
